<script>
import {
  maxValue,
  minValue,
  required,
  requiredIf
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["complianceLimits"])
  },
  methods: {
    employerOtherValidations(design) {
      if (!this.showForm(design))
        return {
          plan_has_profit_sharing_contributions_picklist_id: { required }
        };
      return {
        plan_has_profit_sharing_contributions_picklist_id: { required },
        age_requirement_profit_sharing: { required },
        age_requirement_profit_sharing_years: {
          required: requiredIf(() => this.showAgeRequirement(design)),
          minValue: minValue(design.age_requirement_years || 0),
          maxValue: maxValue(
            design.age_requirement_profit_sharing_months > 0 ? 20 : 21
          )
        },
        age_requirement_profit_sharing_months: {
          required: requiredIf(() => this.showAgeRequirement(design)),
          minValue: minValue(design.age_requirement_months || 0),
          maxValue: maxValue(
            design.age_requirement_profit_sharing_years > 20 ? 0 : 12
          )
        },
        service_requirement_profit_sharing: { required },
        service_requirement_profit_sharing_measurement_number: {
          required: requiredIf(() => this.showServiceRequirement(design)),
          minValue: minValue(
            design.service_requirement_measurement_number || 0
          ),
          maxValue: maxValue(24)
        },
        profit_sharing_allocation_method: { required },
        profit_sharing_amount_percent: {
          required: requiredIf(() =>
            this.showCompensationPercentOrDollarLimit(design)
          ),
          minValue: minValue(0.01),
          maxValue: maxValue(0.25),
          percent: true
        },
        employer_other_flat_dollar_amount: {
          required: requiredIf(() => this.showFlatDollarAmount(design)),
          minValue: minValue(1),
          maxValue: maxValue(this.complianceLimits.max_contribution_dc_plan),
          currency: true
        },
        employer_other_integrated_base_percent_below: {
          required: requiredIf(() => this.showIntegratedBase(design)),
          minValue: minValue(0),
          maxValue: maxValue(this.maxBelowPercentSSI(design)),
          percent: true
        },
        employer_other_integrated_wage_base: {
          required: requiredIf(() => this.showIntegratedBase(design)),
          minValue: minValue(
            this.complianceLimits.social_security_wage_base * 0.2
          ),
          maxValue: maxValue(this.complianceLimits.social_security_wage_base),
          currency: true
        },
        employer_other_integrated_base_percent_above: {
          required: requiredIf(() => this.showIntegratedBase(design)),
          minValue: minValue(0),
          maxValue: maxValue(this.maxAbovePercentSSI(design)),
          percent: true
        },
        employer_other_dollar_maximum: {
          required: requiredIf(() =>
            this.showCompensationPercentOrDollarLimit(design)
          )
        },
        employer_other_dollar_maximum_amount: {
          required: requiredIf(() => this.showDollarLimitAmount(design)),
          minValue: minValue(1),
          maxValue: maxValue(this.complianceLimits.max_contribution_dc_plan),
          currency: true
        },
        employer_other_vesting_immediate: { required },
        percent_profit_sharing_vesting_1_year: {
          required: requiredIf(() => this.showVestingImmediateGraded(design) || this.showVestingImmediateCliff(design)),
          minValue: minValue(0),
          maxValue: maxValue(1),
          percent: true
        },
        percent_profit_sharing_vesting_2_year: {
          required: requiredIf(() => this.showVestingImmediateGraded(design) || this.showVestingImmediateCliff(design)),
          minValue: minValue(this.minVestingYears(design, 2)),
          maxValue: maxValue(1),
          percent: true
        },
        percent_profit_sharing_vesting_3_year: {
          required: requiredIf(() => this.showVestingImmediateGraded(design) || this.showVestingImmediateCliff(design)),
          minValue: minValue(this.showVestingImmediateCliff(design) ? 1 : this.minVestingYears(design, 3)),
          maxValue: maxValue(1),
          percent: true
        },
        percent_profit_sharing_vesting_4_year: {
          required: requiredIf(() => this.showVestingImmediateGraded(design)),
          minValue: minValue(this.minVestingYears(design, 4)),
          maxValue: maxValue(1),
          percent: true
        },
        percent_profit_sharing_vesting_5_year: {
          required: requiredIf(() => this.showVestingImmediateGraded(design)),
          minValue: minValue(this.minVestingYears(design, 5)),
          maxValue: maxValue(1),
          percent: true
        },
        percent_profit_sharing_vesting_6_year: {
          required: requiredIf(() => this.showVestingImmediateGraded(design)),
          minValue: minValue(1),
          maxValue: maxValue(1),
          percent: true
        },
        employer_other_funding_frequency: { required },
        employer_other_fixed_or_discretionary: { required },
        profit_sharing_basic_require_last_day: { required },
        employer_other_annual_service_reqt: { required },
        employer_other_annual_service_reqt_amount: {
          required: requiredIf(() => this.showHoursOrMonths(design)),
          minValue: minValue(1),
          maxValue: maxValue(
            +design.employer_other_annual_service_reqt === 1 ? 12 : 1000
          )
        },
        profit_sharing_excludes_overtime_comp_yesno: { required },
        profit_sharing_excludes_bonus_comp_yesno: { required },
        profit_sharing_excludes_commissions_comp_yesno: { required },
        profit_sharing_excludes_shiftdifferential_comp_yesno: { required }
      };
    },
    showForm(design) {
      return (
        +design.plan_has_profit_sharing_contributions_picklist_id === 1 ||
        +design.plan_has_profit_sharing_contributions_picklist_id === 2
      );
    },
    showAgeRequirement(design) {
      return (
        design.age_requirement_profit_sharing &&
        +design.age_requirement_profit_sharing !== 0 &&
        +design.age_requirement_profit_sharing !== 1
      );
    },
    showServiceRequirement(design) {
      return (
        design.service_requirement_profit_sharing &&
        +design.service_requirement_profit_sharing !== 0 &&
        +design.service_requirement_profit_sharing !== 1
      );
    },
    showCompensationPercentOrDollarLimit(design) {
      return +design.profit_sharing_allocation_method === 1;
    },
    showFlatDollarAmount(design) {
      return +design.profit_sharing_allocation_method === 2;
    },
    showIntegratedBase(design) {
      return +design.profit_sharing_allocation_method === 3;
    },
    showDollarLimitAmount(design) {
      return +design.employer_other_dollar_maximum === 1;
    },
    showVestingImmediateGraded(design) {
      return +design.employer_other_vesting_immediate === 2;
    },
    showVestingImmediateCliff(design) {
      return +design.employer_other_vesting_immediate === 1;
    },
    maxBelowPercentSSI(design) {
      let percent =
        design.employer_other_integrated_wage_base /
        this.complianceLimits.social_security_wage_base;
      if (percent >= 0.2 && percent < 0.8) return 0.043;
      if (percent >= 0.8 && percent < 1) return 0.054;
      if (percent >= 1) return 0.057;
    },
    maxAbovePercentSSI(design) {
      return design.employer_other_integrated_base_percent_below * 2;
    },
    minVestingYears(design, number) {
      let value =
        +design[`percent_profit_sharing_vesting_${number - 1}_year`] || 0;
      value = value >= 1 ? 1 : value;
      return this.showVestingImmediateCliff(design) || value >= this.minDefaultVesting(number) ? value : this.minDefaultVesting(number);
    },
    minDefaultVesting(number) {
      switch (number) {
        case 2: return 0.2;
        case 3: return 0.4;
        case 4: return 0.6;
        case 5: return 0.8;
        default: return 0;
      }
    },
    showHours(design) {
      return +design.employer_other_annual_service_reqt === 2;
    },
    showMonths(design) {
      return +design.employer_other_annual_service_reqt === 1;
    },
    showHoursOrMonths(design) {
      return this.showHours(design) || this.showMonths(design);
    }
  }
};
</script>
